import { render, staticRenderFns } from "./IconWithTooltip.vue?vue&type=template&id=c145dd8e&scoped=true"
import script from "./IconWithTooltip.vue?vue&type=script&lang=ts"
export * from "./IconWithTooltip.vue?vue&type=script&lang=ts"
import style0 from "./IconWithTooltip.vue?vue&type=style&index=0&id=c145dd8e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c145dd8e",
  null
  
)

export default component.exports